import React, {useEffect, useState} from 'react';
import {useSelector} from "react-redux";
import {Button, Col, Container, Row} from 'react-bootstrap';

import {useUpdateEffect} from "../../../Hooks/EffectHooks";
import {useMakePageRequest} from "../../../Hooks/RequestHooks";
import {useCheckAuth} from "../../../Hooks/RouteHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {ContactsTable} from "./Table";
import {ContactsTableFilter} from "./TableFilter";

import {service as ContactService} from "../../../Services/ContactService";
import {StreamBankLink} from "../../Common/StreamBankLink";
import {Glyphicon} from "../../Common/GlyphIcon";

export const ContactsIndexPage = props => {
    useCheckAuth();
    const classNames = useClassNames('sb-contacts-index-page');
    const makePageRequest = useMakePageRequest();
    const {context} = useSelector(state => state.contextState);
    const [contacts, setContacts] = useState(null);

    useUpdateEffect(() => {
        if(context) {
            makePageRequest(
                () => ContactService.GetWithContext(context),
                (x) => setContacts(x.result),
            );
        }
    }, [context]);

    return <Container className={classNames}>
        <Row>
            <Col xs={12} md={6}><h2>Contacts</h2></Col>
            <Col xs={12} md={6}>
                <StreamBankLink Tool="contacts/new">
                    <Button variant="link" className="float-right h3">
                        <Glyphicon glyph="plus-sign" />Add Contact
                    </Button>
                </StreamBankLink>
            </Col>
        </Row>
        <Row>
            <Col xs={12}>
                <hr className="special-hr"/>
            </Col>
        </Row>
        <Row>
            <Col xs={12}>
                <ContactsTable
                    FilterComponent={ContactsTableFilter}
                    Data={contacts}
                />
            </Col>
        </Row>
    </Container>;
};


